import React from "react";
import { Services as SR } from "../constant/Services";
import { Link } from "react-router-dom";
const Services = () => {
  return (
    <section className="py-16">
      <h2 className="text-center uppercase font-bold text-[clamp(2rem,3.5vw,4rem)] mb-[20px] font-[Aquarium]">
        services
      </h2>
      <div>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] ">
          {SR.slice(0, 4).map((service, index) => (
            <Link
              key={index}
              to={`/services/#${service.id}`}
              className="relative group"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <img
                src={service.img}
                alt={service.title}
                className="group-hover:brightness-50 max-md:brightness-50 brightness-[.7] transition-all duration-[.7s]"
              />
              <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-center w-full flex flex-col gap-3 items-center  transition-all duration-[.7s]">
                <h2 className="text-[clamp(1.4rem,1.8vw,4rem)]  font-[Aquarium]  text-center text-white transition-all leading-9 duration-[.7s] relative group-hover:scale-105 max-md:scale-105 before:absolute before:content-[''] group-hover:before:w-full max-md:before:w-full  before:w-0 before:left-[50%] before:-translate-x-[50%] before:h-[2px] before:-bottom-[5px] before:bg-white before:transition-all before:duration-[.7s]">
                  {service.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
        <a
          className="mx-auto block rounded-full text-center w-40 border-2 p-4 mt-10 border-[black]  text-[black] font-semibold hover:bg-[black] hover:text-white transition uppercase"
          type="button"
          href="/services"
        >
          View All
        </a>
      </div>
    </section>
  );
};

export default Services;
